export const DECLARATION_STATUS_MAP = {
  533910000: "Draft",
  533910006: "Approved",
  533910001: "In Progress",
  2: "Inactive",
  533910005: "Rejected",
  533910004: "Submitted",
};
